module.exports = __webpack_public_path__ + "img/92.90520c71.jpg";